import { Injectable } from '@angular/core';
import { JPathService } from '@cv-invision/cv.component-library.ux';

@Injectable({
	providedIn: 'root'
})
export class FormModelService extends JPathService {

	formModel: any;

	public setFormModel(formModel) : any{
		this.formModel = formModel;
	}

	/**
	 * Get the metadata of the schema
	 * @todo return tplus
	 *
	 * @param path
	 */
	getMetadataByPath(path: string): any {
		const searchPath = `$.${path}.Metadata[0]`;
		const tplus = this.getValue(this.formModel, searchPath);

		return tplus;
	}

	/**
	 * Get the metadata of the schema
	 * @todo return tplus
	 *
	 * @param path
	 */
	getAnyMetadataByPath(path: string): any {
		const searchPath = `$..${path}.Metadata[0]`;
		const tplus = this.getValue(this.formModel, searchPath);

		return tplus;
	}

	/**
	 * Get the Enumeration value from the schema
	 * @todo return searchplus
	 *
	 * @param path
	 * @param term
	 */
	getEnumeratedValue(path: string, term: string): string {
		const fullPath = `${path}.Metadata[0].Enumeration..[?(@.Key == "${term}")]`;
		try {
			const search = this.getValue(this.formModel, fullPath) || '';

			if (search !== '') {
				return search.Value;
			}
			return term;
		} catch (error) {
			return term;
		}
	}

	/**
	 * Get a property from the schema
	 * @todo
	 * - Add default initial pointer depending on the schema. Example: InspectionReport
	 * - returns tplus
	 *
	 * @param path
	 */
	getPropertiesByPath(path: string): any {
		path = path === '' ? path : `.${path}`;
		const searchPath = `$${path}`;
		const tplus = this.getValue(this.formModel, searchPath);

		return tplus || {};
	}

	/**
	 * Set the field different paths,
	 */
	public async setPaths(paths: any, options: any): Promise<void> {
		Object.keys(paths).forEach(key => {
			paths[key] = options.path;
		});

		const pathPattern = /(\[[a-zA-z=0-9'\\]+\])/g;
		const matches = paths.path.match(pathPattern);

		if (matches) {
			const jsonPath = paths.path.replace(pathPattern, match => {
				const splitedValues = match.replace(/[[\]']+/g, '').split('=');
				const jsonPathString = '[?(@.' + splitedValues[0] + '.Value==' + splitedValues[1] + ')]';

				return jsonPathString;
			});

			const schema = paths.path.replace(pathPattern, '');

			paths.original = options.path;
			paths.jsonPath = jsonPath;
			paths.schema = schema;
		}
	}

	/**
	 * Wraper for jsonPath query
	 * @todo
	 * - return tplus instead t
	 *
	 * @param data
	 * @param search
	 */
	query(data: any, search: string): any {
		const tplus = this.getQuery(data, search);

		return tplus;
	}

	/**
	 * Wraper for jsonPath query with promises
	 * @param data
	 * @param search
	 */
	async query2(data: any, search: string): Promise<any> {
		const t = await this.query(data, search);
		return t;
	}

	/**
	 * Wraper for jsonPath value
	 * @todo
	 * - return tplus instead t
	 *
	 * @param data
	 * @param search
	 */
	value(data: any, search: string): any {
		const tplus = this.getValue(data, search);
		return tplus;
	}
}
